export default "__VITE_ASSET__1d31a884__"